module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp2",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMEP"
  }, [_vm._v("Nothing is so fatal to the progress of the human mind as to suppose our views of science are ultimate; that there are no new mysteries in nature; that our triumphs are complete; and that there are no new worlds to conquer.")]), _vm._v(" "), _c('div', {
    staticClass: "FMEPC-SP"
  }, [_c('p', {
    staticClass: "FMEPC"
  }, [_vm._v("S"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("IR ")]), _vm._v("H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("UMPHRY ")]), _vm._v("D"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AVY")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0